import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { getErrorToastMessage } from '@/libs/api'
import { QUERY_KEYS, STALE_TIME } from '@/libs/constants'
import type { HookParams, WeeklyNotesData, WeeklyNotesParams } from '@/libs/interfaces'
import { weeklyNotesApi } from '@/services/api'

export function useWeeklyNotes({ params, enabled }: HookParams<WeeklyNotesParams>) {
  return useQuery<WeeklyNotesData>({
    queryKey: QUERY_KEYS.weeklyNotes.list(params),
    enabled: enabled ?? true,
    queryFn: async () => {
      return await weeklyNotesApi.getWeeklyNotes(params)
    },
    staleTime: STALE_TIME['24Hours'],
  })
}

export function useWeeklyNotesCreateOrUpdate() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: weeklyNotesApi.createOrUpdateWeeklyNotes,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.weeklyNotes.all,
      })
    },
    onError: (error) => {
      toast.error(getErrorToastMessage(error, t('common.error')))
    },
  })
}
